export const baseUrl='https://api.themoviedb.org/3';
export const API_KEY ="690608839051dbba64554cb864883401"
export const ImgUrl ="https://image.tmdb.org/t/p/original"